import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';

const Login: React.FC = () => {
  const { loginWithEntra, isLoading, authError, clearAuthError } = useAuth();
  const [error, setError] = useState('');

  const handleMicrosoftSignIn = async () => {
    setError('');
    clearAuthError();

    try {
      await loginWithEntra();
    } catch (loginError) {
      setError(loginError instanceof Error ? loginError.message : 'Microsoft Entra sign-in failed');
    }
  };

  return (
    <div className="login-form">
      {(error || authError) && <div className="alert alert-danger">{error || authError}</div>}
      <button
        className="btn btn-primary microsoft-signin-button"
        type="button"
        disabled={isLoading}
        onClick={handleMicrosoftSignIn}
        title="Sign in with your DevRain Microsoft account"
      >
        <span className="microsoft-mark" aria-hidden="true">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </span>
        {isLoading ? 'Signing in...' : 'Sign in with Microsoft'}
      </button>
    </div>
  );
};

export default Login;
